import { MomentInput } from 'moment';
import React from 'react';
import DateDisplay, { getOnlyDateFormat, getTimeFormat, INVALID_DATE, LayoutType } from './date-display';
import classNames from 'classnames';
import './date-with-time-splitted.scss';

interface Props {
	date: MomentInput | string;
	hourFormat: string;
	showDate?: boolean;
	timezone?: string;
	invalidDateText?: string;
	template?: LayoutType;
}

const DateWithTimeSplitted = ({
	date,
	hourFormat,
	showDate = true,
	timezone,
	invalidDateText,
	template = LayoutType.VERTICAL
}: Props) => {
	const timeFormat = getTimeFormat(hourFormat);
	const dateFormat = getOnlyDateFormat();

	if (!date) {
		return <>{invalidDateText || INVALID_DATE}</>;
	}

	return (
		<>
			{showDate && (
				<div
					className={classNames('date-wrapper', {
						horizontal: template === LayoutType.HORIZONTAL,
						inline: template === LayoutType.INLINE
					})}
				>
					<DateDisplay date={date} format={dateFormat} timezone={timezone} className="date" />
					{showDate && template === LayoutType.INLINE && <span>{', '}</span>}
				</div>
			)}
			<DateDisplay date={date} format={timeFormat} timezone={timezone} className="time" />
		</>
	);
};
export default DateWithTimeSplitted;
